<div class="mat-card-subtitle">
  <span [translate]="'parameters/whatsapp-templates/description-1'"></span><br />
  <span [translate]="'parameters/whatsapp-templates/description-3'"></span>&nbsp;
  <a
    href="https://developers.facebook.com/docs/whatsapp/api/messages/message-templates/"
    rel="noopener noreferrer nofollow"
    target="_blank"
    >https://developers.facebook.com/docs/whatsapp/api/messages/message-templates/</a
  >
</div>

<app-search-bar
  [primaryButtonAction]="primaryButtonAction"
  [primaryButtonKey]="'parameters/whatsapp-templates/add-template-button'"
  [secondaryButtonAction]="secondaryButtonAction"
  [secondaryButtonKey]="'parameters/whatsapp-templates/synchronize-with-meta-button'"
  [searchKey]="'parameters/whatsapp-templates/search-placeholder'"></app-search-bar>

<app-table [config]="config" [filters]="filters"></app-table>

<ng-template #answerTemplatesDependenciesTemplateRef>
  <div *ngIf="answerTemplatesDependencies?.length; else noDependenciesFound">
    <p>⚠️&nbsp;<span translate="parameters/whatsapp-templates/delete/dependencies-found"></span></p>
    <li *ngFor="let dependency of answerTemplatesDependencies">
      <a [href]="dependency.url" rel="noopener noreferrer" target="_blank">{{ dependency.name }}</a>
    </li>
  </div>
  <ng-template #noDependenciesFound>
    <p>✔️&nbsp;<span translate="parameters/whatsapp-templates/delete/no-dependencies-found"></span></p>
  </ng-template>
</ng-template>

<ng-template #templateNameRef let-url="url" let-name="name" let-categoryLabel="categoryLabel">
  <a [href]="url">{{ name }}</a>
  <p class="description">
    {{ categoryLabel }}
  </p>
</ng-template>

<ng-template #languagesBodyRef let-languages="languages" let-text="text">
  <strong>{{ languages }}</strong>
  <div class="description">{{ text }}</div>
</ng-template>
